import React, { useCallback, useEffect, useState } from 'react';

import { deprecateKey } from 'src/services/rules';

import integration from 'src/lib/api/integration';
import jira from 'src/lib/api/jira';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import ModalContainer from 'src/views/components/ModalContainer';

import RuleForm from './RuleForm';

const EditRuleModal = ({ ruleId }) => {
  const [rule, setRule] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    integration
      .getRule(ruleId)
      .then(rule => deprecateKey(rule, 'pd_run_response_play'))
      .then(rule => setRule(rule))
      .catch(error => setError(error));
  }, [ruleId]);

  const onSave = useCallback(async (rule) => {
    const response = await integration
      .updateRule(ruleId, rule)
      .catch(e => Promise.reject(['Failed to update Rule', e]));
    await jira.setSidebarVisibility(response.config?.projects, false)
      .catch(e => console.error('Failed to set sidebar visibility on update rule', e));
    return response;
  }, [ruleId]);

  const ruleName = (rule && `"${rule.name}"`) || '';

  return (
    <ModalContainer title={`Edit rule ${ruleName}`}>
      {(!error && !rule) && <CenteredSpinner size="large"/> }
      {error && <ErrorMessage error={['Can not load rule', error]}/>}
      {rule && <RuleForm rule={rule} onSave={onSave} />}
    </ModalContainer>
  );
};

export default EditRuleModal;
